import { PrimaryButton } from "@nib-components/button";
import Copy from "@nib-components/copy";
import Heading from "@nib-components/heading";
import { Box, Column, Columns, Stack } from "@nib/layout";
import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";
import { Margin, Padding } from "styled-components-spacing";
import useWindowDimensions from "../../utils/breakpoints";

import pregnancyImageMobile from "./images/Pregnant-Woman-Relaxing-With-Tea-400w.jpg";
import pregnancyImage from "./images/Pregnant-Woman-Relaxing-With-Tea-Desktop-@2x.jpg";

import Container from "@nib-components/container";

const StyledHeading = styled(Heading)`
  text-align: left;
  ${breakpoint("md")`
    text-align: left;
  `}
`;

const ProductCTA = ({ copy, title }) => {
  return (
    <Copy component="ul">
      <Copy component="li">{title}</Copy>
      <Copy component="li">{copy}</Copy>
    </Copy>
  );
};

const StyledImage = styled.img`
  max-height: 450px;
  width: 100%;

  ${breakpoint("md")`
    max-height: 600px;

  `}
`;
const ProductIntro = ({ content, title, description, pricing, image, onClick }) => {
  const { cta } = content;
  const { isMobile } = useWindowDimensions();
  return (
    <Margin vertical={7} top={{ xs: 0 }}>
      <Container>
        <Columns space={{ xs: 2, lg: 4 }} collapseBelow="lg" reverse={isMobile}>
          <Padding
            horizontal={{
              xs: 4,
              md: 6,
              lg: 8,
            }}
          >
            <Column width={{ xs: 1, lg: "1/2" }}>
              <Margin top={{ xs: 5, lg: 9 }}>
                <Stack space={{ xs: 2, md: 4 }} verticalAlign="center">
                  <StyledHeading component="h2" size={{ xs: 2, lg: 1 }}>
                    {title}
                  </StyledHeading>
                  <Copy>{description.short}</Copy>
                  <Copy>{description.long}</Copy>
                  {cta.map(({ copy, title: ctaTitle }, index) => (
                    <ProductCTA key={index} copy={copy} title={ctaTitle} />
                  ))}
                  <Margin bottom={{ xs: 8 }} top={{ xs: 6 }}>
                    <PrimaryButton size="large" onClick={onClick}>
                      Learn more
                    </PrimaryButton>
                  </Margin>
                </Stack>
              </Margin>
            </Column>
          </Padding>
          <Column width={{ xs: 1, lg: "1/2" }} style={{ alignSelf: "center" }}>
            <Padding horizontal={{ xs: 0, md: 6, lg: 8 }}>
              <Box marginTop={{ xs: 1, lg: 7 }}>
                {isMobile ? (
                  <StyledImage
                    src={pregnancyImageMobile} //TODO:: Replace with image.url
                    alt={image.alt} //TODO:: These should be sourced from a CDN, so that it isn't hardcoded per product.
                  />
                ) : (
                  <StyledImage
                    src={pregnancyImage} //TODO:: Replace with image.url
                    alt={image.alt} //TODO:: These should be sourced from a CDN, so that it isn't hardcoded per product.
                  />
                )}
              </Box>
            </Padding>
          </Column>
        </Columns>
      </Container>
    </Margin>
  );
};

ProductIntro.propTypes = {
  content: PropTypes.shape({
    contentType: PropTypes.string,
    cta: PropTypes.arrayOf(
      PropTypes.shape({
        copy: PropTypes.string,
        title: PropTypes.string,
      })
    ),
    items: PropTypes.arrayOf(PropTypes.string),
    title: PropTypes.string,
  }),
  description: PropTypes.shape({
    long: PropTypes.string,
    short: PropTypes.string,
  }),
  title: PropTypes.string,
  pricing: PropTypes.shape({
    action: PropTypes.string,
    amount: PropTypes.number,
  }),
  image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
  }),
};

export default ProductIntro;
